import { Monitor, Moon, Sun } from 'lucide-react';

import { themePreferenceOrder, useTheme } from './useTheme';

import type { ThemePreference } from './useTheme';
import type { ReactElement } from 'react';

const themeIcons: Readonly<Record<ThemePreference, typeof Monitor>> = {
    system: Monitor,
    light: Sun,
    dark: Moon,
};

export function ThemeControl({
    label,
    labels,
    nextLabel,
}: {
    label: string;
    labels: Readonly<Record<ThemePreference, string>>;
    nextLabel: (theme: string) => string;
}): ReactElement {
    const { preference, selectNextTheme } = useTheme();
    const currentIndex = themePreferenceOrder.indexOf(preference);
    const nextPreference =
        themePreferenceOrder[(currentIndex + 1) % themePreferenceOrder.length] ?? 'system';
    const accessibleLabel = `${label}: ${labels[preference]}. ${nextLabel(labels[nextPreference])}`;
    const Icon = themeIcons[preference];
    return (
        <button
            className='icon-button'
            type='button'
            aria-label={accessibleLabel}
            title={accessibleLabel}
            onClick={selectNextTheme}
        >
            <Icon aria-hidden='true' />
        </button>
    );
}
